const introResponsive = gsap.matchMedia();

const introTextanim = gsap.timeline({
    scrollTrigger: {
        trigger: ".fill-text-paragraph",
        start: "0% 40%",
        end: "100% 50%",
        scrub: true,
        // markers: true,
    }
})

introTextanim.to('.overflow-hidden .fill-text-hover-row', {
    width: "100%",
    stagger: 0.5,
})

introResponsive.add("(min-width: 569px)", () => {
    gsap.set('.about-page-intro .rounded-div-wrapper', {
        height: "100px",
    })
})

introResponsive.add("(max-width: 568px)", () => {
    gsap.set('.about-page-intro .rounded-div-wrapper', {
        height: "70px",
    })
})

const at2 = gsap.timeline({
    scrollTrigger: {
        trigger: ".about-page-intro .rounded-div-wrapper",
        start: "0% 40%",
        end: "100% 20%",
        scrub: true,
        // markers: true,
    }
})

at2.to('.about-page-intro .rounded-div-wrapper', {
    height: "0px",
})